import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=fbf2e8b2&scoped=true&"
import script from "./TaxInvoice.vue?vue&type=script&lang=js&"
export * from "./TaxInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoice.vue?vue&type=style&index=0&id=fbf2e8b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf2e8b2",
  null
  
)

export default component.exports